import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import PropTypes from 'prop-types';

import { withRouter } from 'react-router-dom';
import ReactRouterPropTypes from 'react-router-prop-types';

import { isEqual } from 'lodash-es';
import { fromJS } from 'immutable';

import { withSnackbar } from 'notistack';

import { CircularProgress } from 'react-md';

import * as partiesActions from '../../Services/Parties/actions';
import * as contractsActions from '../../Services/Contracts/actions';
import PhysicalPerson from './PhysicalPerson';
import LegalPerson from './LegalPerson';
import { showAlerts } from '../Common/utils';

import './EditParty.scss';

class EditParty extends Component {
  constructor(props) {
    super(props);

    this.state = {
      party: {
        id: undefined
      }
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let nextState = null;
    const { party: prevParty } = prevState;
    const { parties } = nextProps;
    if (prevParty && typeof prevParty.id !== 'undefined' && parties) {
      const nextParty = parties.getIn([prevParty.id])
        ? parties.getIn([prevParty.id]).toJS()
        : undefined;
      if (nextParty && !isEqual(nextParty, prevParty)) {
        nextState = { party: { id: prevParty.id, ...nextParty } };
      }
    }

    return nextState;
  }

  componentDidMount() {
    const { match } = this.props;
    this.setState({
      party: {
        id: match.params.id
      }
    });
    this.fetchData(match.params.id);
  }

  componentDidUpdate(prevProps) {
    const { alerts: prevAlerts } = prevProps;
    const { alerts, enqueueSnackbar, strings } = this.props;

    if (alerts && !isEqual(alerts.toJS(), prevAlerts.toJS())) {
      showAlerts({ enqueueSnackbar, alerts, strings });
    }
  }

  fetchData = id => {
    const { actions } = this.props;
    actions.fetchParty({ id });
  };

  updatePartyId = id => {
    this.setState({
      party: {
        id
      }
    });
    this.fetchData(id);
  };

  render() {
    const { pageTitle, canonical, strings, i18n, actions } = this.props;
    const { party } = this.state;
    const helmet = (
      <Helmet>
        <meta charSet="utf-8" />
        <title>{strings[pageTitle] || 'Party'}</title>
        <meta name="description" content={strings[pageTitle] || 'Party'} />
        <link rel="canonical" href={canonical} />
      </Helmet>
    );

    const getParty = () =>
      party.isPerson ? (
        <PhysicalPerson
          party={party}
          strings={strings}
          i18n={i18n}
          updatePartyPerson={actions.updatePartyPerson}
          updatePartyId={this.updatePartyId}
          updatePartyAddresses={actions.updatePartyAddresses}
          updatePartyContacts={actions.updatePartyContacts}
          updatePartyBankAccounts={actions.updatePartyBankAccounts}
          updatePartyRelations={actions.updatePartyRelations}
          changePaymentCard={actions.changePaymentCard}
        />
      ) : (
        <LegalPerson
          party={party}
          strings={strings}
          i18n={i18n}
          updatePartyCompany={actions.updatePartyCompany}
          updatePartyId={this.updatePartyId}
          updatePartyAddresses={actions.updatePartyAddresses}
          updatePartyContacts={actions.updatePartyContacts}
          updatePartyBankAccounts={actions.updatePartyBankAccounts}
          updatePartyRelations={actions.updatePartyRelations}
          changePaymentCard={actions.changePaymentCard}
        />
      );

    return (
      <div className="coog-app party">
        {helmet}
        <h1 className="md-title md-cell md-cell--12">{strings[pageTitle] || 'Party'}</h1>
        <div className="md-body  edit-party">
          {party && party.id ? (
            getParty()
          ) : (
            <CircularProgress
              id="party-loading"
              className="loading"
              scale={3}
              style={{ margin: '2em auto' }}
            />
          )}
        </div>
      </div>
    );
  }
}

EditParty.propTypes = {
  pageTitle: PropTypes.string,
  canonical: PropTypes.string,
  strings: PropTypes.objectOf(PropTypes.string),
  actions: PropTypes.shape({
    getRoute: PropTypes.func,
    fetchContract: PropTypes.func,
    updatePartyPerson: PropTypes.func,
    updatePartyAddresses: PropTypes.func,
    updatePartyContacts: PropTypes.func,
    fetchParty: PropTypes.func,
    updatePartyBankAccounts: PropTypes.func,
    updatePartyRelations: PropTypes.func,
    updatePartyCompany: PropTypes.func,
    changePaymentCard: PropTypes.func
  }),
  match: ReactRouterPropTypes.match.isRequired,
  parties: PropTypes.object, // eslint-disable-line
  i18n: PropTypes.object, // eslint-disable-line
  loading: PropTypes.object, // eslint-disable-line
  enqueueSnackbar: PropTypes.func.isRequired, // eslint-disable-line
  alerts: PropTypes.object // eslint-disable-line
};

EditParty.defaultProps = {
  pageTitle: 'title.party.list',
  canonical: 'http://www.coopengo.com/',
  strings: {},
  actions: {
    getRoute: () => { }
  },
  parties: {},
  loading: fromJS({}),
  alerts: fromJS({ warnings: [], errors: [], successes: [], infos: [] })
};
// eslint-disable-next-line no-unused-vars
const mapStateToProps = state => ({
  alerts: state.getIn(['parties', 'alerts']),
  strings: state.getIn(['parties']).toJS().strings,
  parties: state.getIn(['parties', 'parties']),
  loading: state.getIn(['parties', 'loading']),
  i18n: state.getIn(['system', 'i18n']),
});
// eslint-disable-next-line no-unused-vars
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...partiesActions, ...contractsActions }, dispatch)
});

export default withSnackbar(
  withRouter(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(EditParty)
  )
);
